const LINKED = 'data-linked'

// Violet like the member months, so the ring reads as "the statement this spending is printed on".
export const LINKED_BAR =
  'data-[linked]:outline-2 data-[linked]:-outline-offset-2 data-[linked]:outline-violet-600'

export const LINKED_STITCHED_BAR =
  'group-data-[linked]/stitch:outline-2 group-data-[linked]/stitch:-outline-offset-2 group-data-[linked]/stitch:outline-violet-600'

// Marked straight on the nodes, like a drop target (see carry.ts): pointing at a member month must
// not redraw the whole map. A statement that crosses New Year is one bar per year, so all are marked.
export const linkStatement = (
  from: HTMLElement,
  statementId: string | null,
) => {
  const pane = from.closest('[data-map-pane]')
  if (!pane) return
  for (const node of pane.querySelectorAll(`[${LINKED}]`)) {
    node.removeAttribute(LINKED)
  }
  if (!statementId) return
  for (const node of pane.querySelectorAll(
    `[data-statement-id="${statementId}"]`,
  )) {
    node.setAttribute(LINKED, '')
  }
}
